import styled from 'styled-components';

export const ScreenHeader = styled.div`
  margin-bottom: 20px;
`;
